import { airspaceFootprintKey } from "./webgl-maplibre.airspace-labels";

/** Deduplicate paint only. Callers retain all original records for labels and queries. */
export function uniqueAirspaceGeometry(features: any[]): any[] {
  const seen = new Set<string>();
  const paintKeys = [
    "strokeColor",
    "strokeWidth",
    "lineDash",
    "fillColor",
    "haloColor",
    "haloWidth",
    "innerStrokeColor",
    "innerStrokeWidth",
    "innerStrokeOpacity",
    "zIndex",
  ];
  return features.filter((feature) => {
    if (feature.properties?._objType !== 0) return true;
    const geometry = feature.geometry;
    const polygons =
      geometry.type === "Polygon"
        ? [geometry.coordinates]
        : geometry.type === "MultiPolygon"
          ? geometry.coordinates
          : undefined;
    if (!polygons) return true;
    const footprint = polygons.map(airspaceFootprintKey).sort().join("||");
    // Distinct styled airspaces sharing an area remain visible, e.g. a CTR over a TMA.
    const paint = paintKeys.map((key) => feature.properties[key] ?? null);
    const key = footprint + JSON.stringify(paint);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
